import * as React from 'react';

const ArrowSwitchChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="arrow-switch-chunky_svg__eds-icon--arrow-switch-chunky_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="arrow-switch-chunky_svg__eds-icon--arrow-switch-chunky_down"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 15l-1.4-1.4L8 16.2V5H6v11.2l-2.6-2.6L2 15l5 5z"
        />
        <path
            className="arrow-switch-chunky_svg__eds-icon--arrow-switch-chunky_up"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4 8.6l1.5 1.4 2.5-2.6v11.2h2V7.4L20 10l1.4-1.4-5-5z"
        />
    </svg>
);

ArrowSwitchChunkySvg.displayName = 'ArrowSwitchChunkySvg';
export default ArrowSwitchChunkySvg;
